import React from "react"

const ComponentNotFound = (props) => {
  if (process.env.NODE_ENV === "development")
    return (
      <div>
        Component {props.blok.component} is not defined. Add it to components.js
      </div>
    )
  return null
}

export default ComponentNotFound
